import React, { useState } from 'react';
import './login.css';
import { Link, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../constants';
import Loader from '../../Components/Loader/Loader';
import { toast } from 'react-toastify';
import { updateUserProfile } from '../../Store/App/userProfile';
import { useDispatch } from 'react-redux';

const ForgotPassword = ({ isAdmin }) => {

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const [viewPassword, setViewPassword] = useState(false);


  const handleUserForgotPassword = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${BASE_URL}auth/password/forgot`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // console.log('Forgot successful:', data);
        toast.success(data.message);
      } else {
        // Handle login failure
        const error = await response.json();
        toast.error(error.message)
      }
      setIsLoading(false)
    } catch (error) {
      console.error('An error occurred:', error);
      toast.error('An unexpected error occurred. Please try again later.');
      setIsLoading(false)
    }
  }

  const handleAdminForgotPassword = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${BASE_URL}auth/admin/sign_in`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          password: password,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // console.log('Login successful:', data);
        const { token, refreshToken } = data;
        const { user } = data.data;

        dispatch(updateUserProfile(user))

        // Store tokens and user data securely
        localStorage.setItem('frotaToken', token);
        localStorage.setItem('refreshToken', refreshToken);
        window.dispatchEvent(new Event("storage"));
        // sessionStorage.setItem('user', JSON.stringify(user)); // Use sessionStorage for user data

        // Redirect or navigate to dashboard after a short delay (optional)
        navigate('/admin-dashboard');
      } else {
        // Handle login failure
        const error = await response.json();
        console.error('Login failed:', error);
        toast.error('Login failed. Please check your credentials.');
        setIsLoading(false)
      }
    } catch (error) {
      console.error('An error occurred:', error);
      toast.error('An unexpected error occurred. Please try again later.');
      setIsLoading(false)
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email) {
      toast.error('Enter a Valid Email.')
      return;
    }

    if (isAdmin) {
      handleAdminForgotPassword();
    } else {
      handleUserForgotPassword();
    }


  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="page-content">
        <div className="login-container" style={{ opacity: 1 }}>
          <div className="title-container">
            <h2 className="title">FORGOT PASSWORD</h2>
          </div>
          <div className="form-container">
            <form onSubmit={handleSubmit} autoComplete="off">
              <div className="_um_row_1" style={{ marginBottom: '12px' }}>
                <div className="field field-text field-email field-type_text" data-key="email">
                  <div className="field-label">
                    <label htmlFor="email">Email</label>
                  </div>
                  <div className="field-area">
                    <input
                      className="form-field valid"
                      type="text"
                      name="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder={isAdmin ? "Enter Admin's Email" : "Enter User's Email"}
                      aria-invalid="false"
                    />
                  </div>
                </div>
              </div>
              <div className="col-alt">
                <div className="login-btn-container">
                  <button type="submit" className="login-button" id="submit-btn">Forgot Password</button>
                </div>
              </div>
              {/* <div className="forgot-password-container">
                <Link to="/Forgot-password" className="forgot-text">
                  Forgot your password?
                </Link>
              </div> */}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
